export default "__VITE_ASSET__T7bqLFs3__"